import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/batch_run/batch_run/');

const state = {
    ...current_module.state,
    columns: [
        {text: 'Notion ID*', value: 'notion_id', sortable: true, filterable: true, divider: true,},
        // {text: 'Created on', value: 'created_on', sortable: true, divider: true,},
        // {text: 'Edited by*', value: 'edited_by_name', sortable: true, divider: true,},
        // {text: 'Edited on', value: 'edited_on', sortable: true, divider: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: 250,
        sortBy: ['id'],
        sortDesc: [true],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
    statusBatchRun: [
        {name: 'to-do', color: 'grey lighten-5'},
        {name: 'in Bearbeitung', color: 'amber lighten-5'},
        {name: 'geblockt', color: 'red lighten-5'},
        {name: 'fertig', color: 'light-green lighten-5'},
        {name: 'im Lager', color: 'orange lighten-5'},
    ],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        BatchRunMain: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}